import { useFacetNavigation } from '@/data/Content/FacetNavigation';
import { ContentContext } from '@/data/context/content';
import { ProductFacetEntry } from '@/data/types/Product';
import { Grid } from '@mui/material';
import { FC, useCallback, useContext } from 'react';

type Props = {
	entry: ProductFacetEntry;
};

export const CardEntry: FC<Props> = ({ entry }) => {
	const { selectedFacet, onFacetSelectChange } = useContext(ContentContext) as ReturnType<
		typeof useFacetNavigation
	>;
	const onChange = useCallback(
		(event: any) => onFacetSelectChange(event, entry),
		[entry, onFacetSelectChange]
	);

	const isSelected =
		selectedFacet !== undefined ? selectedFacet.indexOf(entry.value) > -1 : undefined;

	return (
		<Grid
			item
			id={`${entry.label} (${entry.count})`}
			data-testid={`${entry.label} (${entry.count})`}
			onClick={onChange}
			sx={{
				borderRadius: '4px',
				border: '1px solid #C9C9C9',
				fontSize: 'var(--font-size-default)',
				color: isSelected ? 'button.primary' : '#2C2C2C',
				fontWeight: 'normal',
				p: '10px 0',
				textAlign: 'center',
				width: '100%',
				backgroundColor: isSelected ? '#e8f3ff' : 'transparent',
				cursor: 'pointer',
			}}
		>
			{`${entry.label}`}
		</Grid>
	);
};
